export const APP_API_CALL_ERROR = "APP_API_CALL_ERROR";

export const APP_SIDE_NAV_VIEW_CHANGE = "APP_SIDE_NAV_VIEW_CHANGE";
export const APP_SIDE_NAV_MINIMIZE = "APP_SIDE_NAV_MINIMIZE";
export const APP_SIDE_NAV_TOGGLE = "APP_SIDE_NAV_TOGGLE";

export const APP_VERSION_CHANGE = "APP_VERSION_CHANGE";
export const APP_CURRENT_VERSION = 3.98;

export const APP_CACHE_RESET_TIMESTAMP = "APP_CACHE_RESET_TIMESTAMP";
export const APP_SET_CACHE_RESET_TIMESTAMP = "APP_SET_CACHE_RESET_TIMESTAMP";

export const COMMAND_MENU = [
    {
        heading: "Orders",
        id: "orders",
        items: [
            {
                id: "orders",
                children: "Orders",
                icon: "ShoppingCartIcon",
                href: "/order",
            },
        ],
    },
    {
        heading: "Customers",
        id: "customers",
        items: [
            {
                id: "customers",
                children: "Customers",
                icon: "UsersIcon",
                href: "/customer",
            },
            {
                id: "create_customer",
                children: "Create customer",
                icon: "UserPlusIcon",
                href: "/customer/create",
            },
        ],
    },
    {
        heading: "Invoices",
        id: "invoices",
        items: [
            {
                id: "invoices",
                children: "Invoices",
                icon: "ClipboardDocumentListIcon",
                href: "/invoice",
            },
            {
                id: "create_invoice",
                children: "Create invoice",
                icon: "DocumentPlusIcon",
                href: "/invoice/create",
            },
        ],
    },
    {
        heading: "Payments",
        id: "payments",
        items: [
            {
                id: "payments",
                children: "Payments",
                icon: "CurrencyDollarIcon",
                href: "/payment",
            },
        ],
    },
    {
        heading: "Stamps",
        id: "stamps",
        items: [
            {
                id: "stamps",
                children: "Stamps",
                icon: "CreditCardIcon",
                href: "/stamp",
            },
            {
                id: "stamp_rollls",
                children: "Manage Rolls",
                icon: "DocumentDuplicateIcon",
                href: "/stamp/roll",
            },
        ],
    },
    {
        heading: "Products",
        id: "products",
        items: [
            {
                id: "products",
                children: "Products",
                icon: "TrophyIcon",
                href: "/payment",
            },
        ],
    },
];
